export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./game-boldplay.vue?vue&type=template&id=6e7863d9&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-boldplay.vue?vue&type=template&id=6e7863d9&scoped=true
// module id = ou+F
// module chunks = 0